import { TextFading } from '@yes.technology/react-toolkit'
import type { MouseEventHandler } from 'react'
import { CardLayout, GanttCard as GanttCardModel } from '../Gantt.utils'
import { CardButton, SELECTED_CARD_BORDER_COLOR } from '../GanttChart.styles'

type GanttCardProps = {
  card: GanttCardModel
  layout: CardLayout
  backgroundColor?: string
  isSelected: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
  onMouseEnter: MouseEventHandler<HTMLButtonElement>
  onMouseLeave: MouseEventHandler<HTMLButtonElement>
}

const GanttCard = ({
  card,
  layout,
  backgroundColor: backgroundColorProp,
  isSelected,
  onClick,
  onMouseEnter,
  onMouseLeave
}: GanttCardProps) => {
  const backgroundColor = backgroundColorProp ?? card.color ?? '#dbeafe'

  return (
    <CardButton
      type='button'
      aria-pressed={isSelected}
      data-gantt-card-id={card.id}
      $left={layout.left}
      $top={layout.top}
      $width={layout.width}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        backgroundColor,
        borderColor: isSelected ? SELECTED_CARD_BORDER_COLOR : 'transparent'
      }}
      data-testid={`gantt-card-${card.id}`}
    >
      <TextFading backgroundColor={backgroundColor}>{card.label}</TextFading>
    </CardButton>
  )
}

export default GanttCard
